import React, { HTMLAttributes } from "react";
import ContactUsForm from "../../../components/molecules/contactUsForm";
import Footer from "../../../components/molecules/footer";
import Header from "../../../components/molecules/header";
import ContactUsSwiper from "./swiperList";
interface IContactUs {}

type TContactUsProps = IContactUs & HTMLAttributes<HTMLDivElement>;

const ContactUs: React.FC<TContactUsProps> = (props) => {
  const { ...otherProps } = props;

  return (
    <div
      className="flex flex-col min-h-[100dvh] h-full text-white"
      {...otherProps}
    >
      <Header />
      <div className="flex flex-1 flex-col laptop:flex-row gap-5 laptop:gap-10 mx-[10%] laptop:mx-[10%] py-16">
        <div className="flex flex-col flex-1 gap-10 laptop:gap-6">
          <div className="flex flex-row gap-4 text-white items-center font-bold">
            <h1 className="text-4xl text-center laptop:text-left">聯絡我們</h1>
            <h1 className="text-2xl text-center laptop:text-left">
              Contact Us
            </h1>
          </div>
          <div className="flex flex-col gap-4 laptop:mb-5">
            <span className="text-sm laptop:text-xl text-white ">
              有任何新的想法嗎?或是正為你的物業尋找合適的充電解決方案。首先填寫我們的聯絡表格。我們將為你指明正確的方向！
            </span>
            <span className="text-xs laptop:text-base text-white ">
              Do you have any new ideas? Or are you looking for suitable
              charging solutions for your property? First, please fill out our
              contact form. We will point you in the right direction!
            </span>
          </div>
          <ContactUsSwiper />
        </div>
        <div className="flex flex-col flex-1">
          {/* form section */}
          <ContactUsForm />
        </div>
      </div>
      <Footer showConactUsButton={false} />
    </div>
  );
};

export default ContactUs;
